import React, { useState } from "react";
import ExportButton from "../Export";
import ExportModal from "../../../Modals/ExportDialogModal";

const ExportWithOptionsButton = ({
  filters,
  sorting,
  total,
  filterType,
  campaignId,
  suppressedUserIds,
  onExportComplete,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ExportButton onClick={() => setOpen(true)} isLoading={false} />
      <ExportModal
        open={open}
        onClose={() => setOpen(false)}
        filters={filters}
        sorting={sorting}
        total={total}
        filterType={filterType}
        campaignId={campaignId}
        suppressedUserIds={suppressedUserIds}
        onExportComplete={onExportComplete}
      />
    </>
  );
};

export default ExportWithOptionsButton;
